export default {
  title: '2D и 3D планировки за 24 часа с виртуальным туром с помощью ИИ | Hart Estate',
  description: 'Готовые 2D и 3D планы с виртуальным туром всего за 24 часа по цене в 3 раза дешевле остальных на рынке.',
  keywords: 'Создание планировок, 2D планировки, 3D планировки, виртуальные туры, ИИ для недвижимости, быстрые планировки, планировка за 24 часа, Hart Estate, ИИ в недвижимости, реклама недвижимости, услуги для застройщиков, 3D визуализация недвижимости',
  hostname: 'https://hart-estate.ru',
};
